import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qa-skipped-verses flex col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "skipped verses", -1)
const _hoisted_3 = { class: "qa-sv-unskip-all margin-center flex row justify-space-b" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("clear selection")
const _hoisted_5 = { class: "grow-1 scroll-y" }
const _hoisted_6 = { class: "qa-sv-verses margin-center h-100" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("unskip")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        text: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.clearSelection()), ["prevent"])),
        class: _normalizeClass({ invisible: !_ctx.selected.length })
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_Button, {
        text: "",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.unskipAll()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode("unskip " + _toDisplayString(_ctx.selected.length > 0 ? 'selected' : 'all'), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skipped, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `skipped-${s.display}`,
            class: _normalizeClass(["qa-sv-verse flex row justify-space-b align-c", { selected: s.selected }]),
            onClick: _withModifiers(($event: any) => (s.selected ? _ctx.deselect(i) : _ctx.select(i, $event)), ["prevent"])
          }, [
            _createElementVNode("span", null, _toDisplayString(s.display), 1),
            _createVNode(_component_Button, {
              text: "",
              onClick: _withModifiers(($event: any) => (_ctx.unskip(s.index)), ["prevent","stop"]),
              class: "qa-sv-unskip-button"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ], 10, _hoisted_7))
        }), 128))
      ])
    ])
  ]))
}